<template>
	<div>
		<div class="modal-game" v-if="$store.state.authentication.loading">
			<loading />
		</div>
		<PlayModal />
		<!-- <Confirm title="tets" :active.sync="active" @onCancel="testFunc" @onConfirm="testFunc" /> -->
		<div v-show="$store.state.authentication.url.length == 0">
			<notifications></notifications>
			<Header />
			<div class="md-layout md-align-center body-padding">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-10 md-medium-size-15 md-size-15"></div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-80 md-medium-size-70 md-size-70">
					<router-view></router-view>
					<Footer />
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-10 md-medium-size-15 md-size-15"></div>
			</div>
			<div style="padding-bottom: 77px" class="only-mobile"></div>
			<BottomMenu />
		</div>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import BottomMenu from '@/components/BottomMenu.vue'
	import Footer from '@/components/Footer.vue'
	import PlayModal from '@/components/PlayModal.vue'
	// import Confirm from '@/components/Confirm.vue'
	export default {
		components: {
			Header,
			BottomMenu,
			Footer,
			PlayModal,
			// Confirm
		},
		data() {
			return {
				default: null,
				confirmClose: false,
				active: true
			}
		},
		created() {
			console.log()
		},
		methods: {
			testFunc() {
				this.active = false;
			}
		}
	}
</script>
<style>
	a:hover {
		text-decoration: none !important;
	}
	.green {
		background-color: rgb(55, 146, 55);
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #c189ee;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #EA5455;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: red;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.margin-bottom-15 {
		margin-bottom: 15px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Nunito", "Hanuman" !important;
	}

	.vdatetime {
		width: 100%;
	}
	/* 135 height */
	.body-padding {
		margin-top: 165px !important;
	}
	@media (min-width: 992px) and (max-width: 1464px){
		.body-padding {
			margin-top: 165px !important;
		}
	}
	@media (min-width: 1199px) and (max-width: 1399px){
		.body-padding {
			margin-top: 165px !important;
		}
	}


	@media (min-width: 992px) and (max-width: 1199px){
		.body-padding {
			margin-top: 165px !important;
		}
	}

	@media screen and (max-width: 991px){
		.body-padding {
			margin-top: 155px !important;
		}
	}
	.modal-game {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0,0,0,0.7);
	}
	.modal-play {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999;
		background-color: #000;
	}
	.action-button {
		position: fixed;
		right: 5px;
		width: 40px;
		height: 40px;
		cursor: pointer;
		border-radius: 40px;
		background-color: rgba(255,255,255,0.5);
		opacity: 0.4;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999999999;
		color:#000;
	}
	.confirm-box {
		z-index: 999999;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		background-color: rgba(0,0,0,0.7);
	}
	.confirm-message {
		width: 100%;
		text-align: center;
		padding: 18px 0;
	}
	.confirm-bottom {
		display: flex;
		justify-content: center;
	}
	.confirm-box-message {
		background-color: #FFF;
		border-radius: 15px;
		width: 100%;
		padding: 0px 20px;
		max-width: 360px;
	}
	.confirm-text-message {
		text-align: center;
		color: #333;
	}
	/* .router-link-active > button > span {
		color: #fa5500 !important;
	} */
	.router-link-active > .nav-link {
		background-color: #135F87 !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue